import { Observable } from 'rxjs';

import { DialogResult, DialogService } from 'dspx-core';

export class SharedSimplePopup {

  constructor(private dialogService: DialogService) {
  }

  showFeatureNotImplementedPopup(): Observable<DialogResult> {
    return this.dialogService.showSimplePopup('This feature has not been implemented yet.', 'Feature Not Implemented', 'Close');
  }

  showNotSupportedWhenOfflinePopup(): Observable<DialogResult> {
    return this.dialogService.showSimplePopup('Cannot execute this task when the system is offline.', 'System Offline', 'Close');
  }

  showNoPermissionPopup(): Observable<DialogResult> {
    return this.dialogService.showSimplePopup('User does not have permission to execute this task.', 'Unauthorised', 'Close');
  }

  showNoItemsSelectedPopup(): Observable<DialogResult> {
    return this.dialogService.showSimplePopup('Please select at least one item from the list below using the checkboxes on the left-hand side.', 'No items selected.', 'Close');
  }
}
